import { DataCapture } from "./DataCapture"
import { isValidPhoneNumber } from "react-phone-number-input"

export interface Participant {
  sessionId: string
  email: string | null
  firstName: string | null
  lastName: string | null
  phoneNumber: string | null
  acceptedTerms: Date | null
}

export function isValidEmail(email: string): boolean {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email)
}

export function hasExpectedData(participant: Participant, dataCapture: DataCapture): boolean {
  if (
    (dataCapture.emailOn && (participant.email === null || !isValidEmail(participant.email))) ||
    (dataCapture.firstNameOn && !participant.firstName) ||
    (dataCapture.lastNameOn && !participant.lastName) ||
    (dataCapture.phoneNumberOn &&
      (participant.phoneNumber === null || !isValidPhoneNumber(participant.phoneNumber)))
  )
    return false

  const anyFieldOn =
    dataCapture.emailOn ||
    dataCapture.firstNameOn ||
    dataCapture.lastNameOn ||
    dataCapture.phoneNumberOn
  if (anyFieldOn && !participant.acceptedTerms) return false

  return true
}
